import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import logoImage from "@/assets/holionix-logo.jpeg";
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  
  const footerLinks = {
    [t('footer.solutions')]: [
      { name: t('footer.inbound'), path: "/solutions" },
      { name: t('footer.outbound'), path: "/solutions" },
      { name: t('footer.automation'), path: "/solutions" },
    ],
    [t('footer.platform')]: [
      { name: t('footer.technology'), path: "/platform" },
      { name: t('footer.integrations'), path: "/platform" },
      { name: t('footer.security'), path: "/platform" },
    ],
    [t('footer.company')]: [
      { name: t('footer.about'), path: "/about" },
      { name: t('footer.careers'), path: "/careers" },
      { name: t('footer.resources'), path: "/resources" },
    ],
    [t('footer.legal')]: [
      { name: t('footer.privacy'), path: "/privacy" },
      { name: t('footer.terms'), path: "/terms" },
      { name: "Imprint", path: "/imprint" },
      { name: t('footer.compliance'), path: "/compliance" },
    ],
  };

  return (
    <footer className="section-dark border-t border-border/50 pt-16 pb-8 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-t from-gradient-pink via-gradient-purple to-gradient-cyan"></div>
      </div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4 group">
              <div className="relative">
                <img 
                  src={logoImage} 
                  alt="Holionix Logo" 
                  className="h-10 w-10 rounded-lg transition-transform group-hover:scale-110" 
                />
                <div className="absolute inset-0 bg-gradient-to-r from-gradient-pink via-gradient-purple to-gradient-cyan rounded-lg opacity-0 group-hover:opacity-30 blur-xl transition-opacity"></div>
              </div>
              <span className="text-2xl font-bold gradient-brand-text">Holionix</span>
            </Link>
            <p className="text-sm text-foreground/70 mb-4">
              {t('footer.tagline')}
            </p>
            <p className="text-sm text-foreground/70 mb-4">
              📍 {t('footer.location')}
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.linkedin.com/company/holionix"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary/20 to-accent/20 border border-primary/30 flex items-center justify-center hover:bg-primary/30 hover:border-primary/50 transition-all group"
                aria-label="Visit Holionix on LinkedIn"
              >
                <Linkedin className="w-5 h-5 text-primary group-hover:scale-110 transition-transform" />
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-semibold text-foreground mb-4">{category}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground/70 hover:text-accent transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-border/30">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-foreground/60">
              © {new Date().getFullYear()} {t('footer.copyright')}
            </p>
            <Link to="/contact" className="text-sm text-accent hover:text-accent/80 transition-colors font-medium">
              {t('footer.contact_us')} →
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
